import React from 'react';
import {
  FormPageInputItemMailRefusalFlag,
  FormPageInputItemMailRefusalFlagRadio,
  MailRefusalFlagProperty,
  MailRefusalFlagPropertyRadio,
  MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE,
} from 'shared';
import { FormFieldInputProps, hasErrorMessage } from '../shared';
import { MailRefusalFlagRadio } from './MailRefusalFlagRadio';

export type MailRefusalFlagInputProps = Omit<
  FormFieldInputProps<
    MailRefusalFlagProperty,
    FormPageInputItemMailRefusalFlag
  >,
  'onBlur'
>;

const isError = (
  errorMessages: MailRefusalFlagInputProps['errorMessages'],
  displayError = false
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const MailRefusalFlagInput: React.FC<MailRefusalFlagInputProps> = (
  props
) => {
  switch (props.property.inputFormat.inputType) {
    case MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE.radio: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          MailRefusalFlagPropertyRadio,
          FormPageInputItemMailRefusalFlagRadio
        >;
      const displayError = submitted || (touched && touched.isRefused);
      return (
        <MailRefusalFlagRadio
          value={value.isRefused}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
  }
};
